// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2895d3fe-567":"79aedc3d6ae4bcca7bfc","2895d3fe-452":"1732733be1503249725d","2895d3fe-812":"4924017b1a7695436d98","2895d3fe-83":"78bb06807abcf4e5028a"}[chunkId] + ".js";
};